#import "./PolicyAdminFields.graphql"

query GetPolicies {
  policies {
    ...PolicyAdminFields
  }
}
